import { render, staticRenderFns } from "./AttachRoleToPositionsInBulkDialog.vue?vue&type=template&id=082e44f7&scoped=true"
import script from "./AttachRoleToPositionsInBulkDialog.vue?vue&type=script&lang=js"
export * from "./AttachRoleToPositionsInBulkDialog.vue?vue&type=script&lang=js"
import style0 from "./AttachRoleToPositionsInBulkDialog.vue?vue&type=style&index=0&id=082e44f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082e44f7",
  null
  
)

export default component.exports